"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentLogType = exports.PaymentStatus = exports.PaymentType = exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType[AccountType["CHECKING"] = 1] = "CHECKING";
    AccountType[AccountType["SAVINGS"] = 2] = "SAVINGS";
    AccountType[AccountType["SALARY"] = 3] = "SALARY";
    AccountType[AccountType["PAYMENT"] = 4] = "PAYMENT";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["REVERSAL"] = 1] = "REVERSAL";
    PaymentType[PaymentType["CREDITOR_PAYMENT"] = 2] = "CREDITOR_PAYMENT";
    PaymentType[PaymentType["COMPANY_REFUND"] = 3] = "COMPANY_REFUND";
    PaymentType[PaymentType["DEPOSIT"] = 4] = "DEPOSIT";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["PENDING"] = 1] = "PENDING";
    PaymentStatus[PaymentStatus["PAID"] = 2] = "PAID";
    PaymentStatus[PaymentStatus["FAILED"] = 3] = "FAILED";
    PaymentStatus[PaymentStatus["REVERSED"] = 4] = "REVERSED";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PaymentLogType;
(function (PaymentLogType) {
    PaymentLogType[PaymentLogType["TRANSFER_CALL"] = 1] = "TRANSFER_CALL";
    PaymentLogType[PaymentLogType["PAYMENT_CHANGE"] = 2] = "PAYMENT_CHANGE";
    PaymentLogType[PaymentLogType["DEPOSIT_RECEIVED"] = 3] = "DEPOSIT_RECEIVED";
})(PaymentLogType = exports.PaymentLogType || (exports.PaymentLogType = {}));
